/**
 * @author gyb(mocheer)
 * @email `mocheer@foxmail.com`  
 * @since  2017-6-15
 * @see https://github.com/maximeh/leaflet.bouncemarker
 * @see https://github.com/hosuaby/Leaflet.SmoothMarkerBouncing
 * @see https://github.com/lit-forest/leaflet.magicMarker
 * @see https://gitlab.com/IvanSanchez/Leaflet.GLMarkers
 * @see https://github.com/Oliv/leaflet-polycolor
 * @see https://github.com/bbecquet/Leaflet.RotatedMarker
 * @see https://gitlab.com/IvanSanchez/Leaflet.Marker.SlideTo
 * @see https://github.com/MazeMap/Leaflet.LayerGroup.Collision 碰撞检测
 */
import toSpline from '../utils/SmoothSpline';
import load from "@/utils/Loader";
import flame from '../animate/flame';
import firework from '../animate/starfire';
//
let {
  assign: $assign
} = T;
let isIE = T.isIE();
let {
  Canvas,
  point: toPoint,
  Util,
  Polyline,
  Path
} = L;
let {
  requestAnimFrame
} = Util;
let {
  _updatePoly,
  onAdd
} = Canvas.prototype;
/**
 * 
 * @param {*} p 
 * @param {*} angle 弧度值
 */
let toRotate = (p, angle) => {
  angle = Math.atan2(p.y, p.x) + angle;
  let r = Math.sqrt(p.x * p.x + p.y * p.y) //半径
  return {
    x: Math.cos(angle) * r,
    y: Math.sin(angle) * r
  }
}
/**
 * 
 */
Path.include({
  /**
   * 
   */
  onAdd() {
    let {
      options,
      _map,
      _renderer
    } = this;
    if (options.glow || options.flow || options.bounce || options.rotate || options.animate) {
      let {
        __glow,
        __animate,
        __flame
      } = _map;

      let canvasRenderer = __animate;
      if (options.glow || options.flow) {
        canvasRenderer = __glow;
        if (options.flow) {
          options.noClip = true;
          if (options.flowOptions && options.flowOptions.symbol && options.flowOptions.symbol.type === 'arrow') {
            canvasRenderer = __animate;
          }
        }
      }

      canvasRenderer._initPath(this);
      //
      if (options.animate) {
        switch (options.animate.type) {
          case 'flame':
            __flame._initPath(this);
            break;
          case 'firework':
            __flame._initPath(this);
            break;
        }
      }
    }
    _renderer._initPath(this);
    this._reset();
    _renderer._addPath(this);
  },
  /**
   * 
   */
  onRemove() {
    let {
      _map,
      _renderer
    } = this;
    _renderer._removePath(this);
    _map.__glow._removePath(this);
    _map.__animate._removePath(this);
  }
});

let {
  _onClick,
  _onMouseMove,
  _bringToBack,
  _bringToFront,
  _update
} = Canvas.prototype;

/** 
 * Canvas 渲染引擎拓展
 */
Canvas.include({
  _update() {
    this.iconBounds = [];
    _update.call(this);
  },
  // /**
  //  * 
  //  */
  // _bringToBack(layer) {
  //   layer._order && _bringToBack.call(this, layer);
  // },
  // /**
  //  * 
  //  */
  // _bringToFront() {
  //   layer._order && _bringToFront.call(this, layer);
  // },
  _removePath(layer) {
    var order = layer._order;
    var next = order.next;
    var prev = order.prev;

    if (next) {
      next.prev = prev;
    } else {
      this._drawLast = prev;
    }
    if (prev) {
      prev.next = next;
    } else {
      this._drawFirst = next;
    }


    // delete layer._order;

    delete this._layers[L.stamp(layer)];

    this._requestRedraw(layer);
  },
  /**
   * 用来做漫游拖动
   * @param {*} e 
   */
  _onClick(e) {
    if (T.data.pan) return;
    _onClick.call(this, e);
  },
  /**
   * 用来做漫游拖动
   * @param {*} e 
   */
  _onMouseMove(e) {
    if (T.data.pan) return;
    _onMouseMove.call(this, e);
  },
  /**
   * @override 
   */
  onAdd() {
    onAdd.call(this);
    // 设置style
    this.options.style && T(this._container).setStyle(this.options.style);
  },

  /**
   * 绘制圆环，台风四象限
   * @param layer
   */
  _updateCircular(layer) {
    let that = this;
    if (!that._drawing || layer._empty()) {
      return;
    }
    let {
      _ctx: ctx,
    } = that;
    let {
      _point: p,
      _radius
    } = layer;
    //
    let {
      PI
    } = Math;
    let iPI = PI / 2;
    ctx.beginPath();
    ctx.arc(p.x, p.y, _radius[0], 0, iPI, false);
    ctx.arc(p.x, p.y, _radius[1], iPI, PI, false);
    ctx.arc(p.x, p.y, _radius[2], PI, iPI * 3, false);
    ctx.arc(p.x, p.y, _radius[3], iPI * 3, PI * 2, false);
    this._fillStroke(ctx, layer);
  },
  /**
   * 绘制三角形图标
   * @param layer
   */
  _updateTriangle(layer) {
    let that = this;
    if (!that._drawing || layer._empty()) {
      return;
    }
    let {
      _ctx: ctx
    } = that;
    let {
      _point: p,
      _radius: r,
      _radiusY: ry
    } = layer;
    let {
      options
    } = layer;
    let {
      angle
    } = options;
    ry = ry || (r + 2);
    ctx.beginPath();
    let p0 = toRotate({
      x: 0,
      y: -r
    }, angle);
    let p1 = toRotate({
      x: -r,
      y: ry
    }, angle);
    let p2 = toRotate({
      x: r,
      y: ry
    }, angle);
    let {
      x,
      y
    } = p;
    y -= 2; //保持平行线
    ctx.moveTo(x + p0.x, y + p0.y);
    ctx.lineTo(x + p1.x, y + p1.y);
    ctx.lineTo(x + p2.x, y + p2.y);
    ctx.lineTo(x + p0.x, y + p0.y);
    that._fillStroke(ctx, layer);
  },
  /**
   * 
   * 绘制矩形小图标
   * @param layer
   */
  _updateRect(layer) {
    let that = this;
    if (!that._drawing || layer._empty()) {
      return;
    }
    let {
      _ctx: ctx
    } = that;
    let {
      _point: p,
      options,
      _radius: width,
      _radiusY: height
    } = layer;
    let {
      x,
      y
    } = p;
    // 居中
    x -= width / 2;
    y -= height / 2;
    // 线宽像素问题
    x = parseInt(x) + 0.5;
    y = parseInt(y) + 0.5;
    // 开始绘制
    ctx.beginPath();
    ctx.lineWidth = options.weight;
    ctx.strokeStyle = options.color; //'#222';
    if (options.angle) {
      ctx.save();
      ctx.translate(x + width / 2, y + height / 2);
      ctx.rotate(options.angle);
      ctx.rect(-width / 2, -height / 2, width, height);
      ctx.restore();
    } else {
      ctx.rect(x, y, width, height);
    }
    that._fillStroke(ctx, layer);
  },
  /**
   * 绘制图片icon
   * @param layer
   */
  _updateIcon(layer) {
    let that = this;
    let {
      options
    } = layer;
    // options.bounce || options.rotate 旋转动画
    if (!that._drawing || layer._empty() || options.bounce || options.rotate) {
      return;
    }
    let img = layer._loader;
    let {
      _ctx: ctx,
    } = that;
    let p = layer._point;
    let {
      angle,
      size,
      scale,
      collisionFlag
    } = options;

    // 旋转
    ctx.beginPath(); // 待验证
    //
    ctx.globalAlpha = 1; // 待删除，这个是因为绘制旋转边框之后透明度有变化
    let {
      width,
      height
    } = img;

    //
    let [
      dWidth,
      dHeight
    ] = (size || [width, height]);

    if (scale) {
      let zoom = layer._map._zoom;
      let d = (1 << zoom) * scale / (1 << 6);
      dWidth *= d;
      dHeight *= d;
    }
    let dx = -dWidth / 2;
    let dy = -dHeight / 2;
    let bounds = L.bounds(toPoint(p.x + dx, p.y + dy), toPoint(p.x + dx + dWidth, p.y + dy + dHeight));

    let {
      iconBounds
    } = this;
    if (collisionFlag) {

      for (let i = 0, len = iconBounds.length; i < len; i++) {
        let pointBounds = iconBounds[i];
        if (pointBounds.intersects(bounds)) {
          return;
        }
      }
    }
    //

    iconBounds.push(bounds);
    //
    if (angle) {
      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(angle);
      ctx.drawImage(img, dx, dy, dWidth, dHeight);
      ctx.restore();
    } else {
      ctx.drawImage(img, p.x + dx, p.y + dy, dWidth, dHeight);
    }

  },
  /**
   * 
   * @param {*} layer 
   * @param {*} closed 
   */
  _updatePoly(layer, closed) {
    let {
      options
    } = layer;
    // 光滑线，待完善，局部刷新有问题
    if (options.spline) {
      let i, j, len2, from, to;
      let {
        _parts: parts
      } = layer;
      let newPart = layer._parts = []; //
      let len = parts.length;
      for (i = 0; i < len; i++) {
        let lines = [];
        for (j = 0, len2 = parts[i].length - 1; j < len2; j++) {
          from = parts[i][j];
          to = parts[i][j + 1];
          let points = toSpline(from, to, Object(options.spline));
          lines = lines.concat(points.map(item => toPoint(item)))
        }
        newPart[i] = lines;
      }
    }
    //
    _updatePoly.call(this, layer, closed);

    let {
      symbol
    } = options;
    //
    //符号 箭头
    if (symbol) {
      let {
        type
      } = symbol;
      let {
        _ctx: ctx
      } = this;
      ctx.beginPath();
      ctx.fillStyle = ctx.strokeStyle = symbol.color || options.color;
      //
      let i, j, len2, from, to;
      let {
        _parts: parts
      } = layer;
      let len = parts.length;
      switch (type) {
        case 'dike': // 堤防
        case 'seawall': // 海塘
          for (i = 0; i < len; i++) {
            for (j = 1, len2 = parts[i].length; j < len2; j++) {
              let p1 = parts[i][j];
              let p2 = parts[i][j - 1];
              let d = p1.distanceTo(p2);
              if (d > 8) {
                let count = d / 8;
                let ml = p1.subtract(p2).divideBy(count);
                // (a,b) 顺时针（b,-a),逆时针（-b,a)
                let mv = toPoint(ml.y, -ml.x);
                for (let i = 1; i < count; i++) {
                  let p = p2.add(ml.multiplyBy(i));
                  let v = p.add(mv);
                  ctx.moveTo(v.x, v.y);
                  if (type == "seawall") {
                    p = p.subtract(mv);
                  }
                  ctx.lineTo(p.x, p.y);
                }
              }
            }
          }
          ctx.stroke();
          break;
        case 'arrow':
        default:
          let _buildArrowPath = function (a, b) {
            let d2r = Math.PI / 180;
            let angle = (Math.atan2(b.y - a.y, b.x - a.x) * 180 / Math.PI + 90 + 360) % 360;
            //(Math.atan2(b.y - a.y, b.x - a.x) * 180 / Math.PI + 90 + 360) % 360;
            var direction = -(angle - 90) * d2r;
            var radianArrowAngle = 60 / 2 * d2r; //默认60°
            //
            var pixelSize = symbol.size || 10; //默认10
            var headAngle1 = direction + radianArrowAngle;
            var headAngle2 = direction - radianArrowAngle;
            var arrowHead1 = toPoint(b.x - pixelSize * Math.cos(headAngle1), b.y + pixelSize * Math.sin(headAngle1));
            var arrowHead2 = toPoint(b.x - pixelSize * Math.cos(headAngle2), b.y + pixelSize * Math.sin(headAngle2));
            return [arrowHead1, arrowHead2];
          }
          for (i = 0; i < len; i++) {
            for (j = 0, len2 = parts[i].length - 1; j < len2; j++) {
              from = parts[i][j];
              to = parts[i][j + 1];
              let [p1, p2] = _buildArrowPath(from, to);
              ctx.moveTo(to.x, to.y);
              ctx.lineTo(p1.x, p1.y);
              ctx.lineTo(p2.x, p2.y);
              ctx.closePath();
              ctx.fill();
              layer._pxBounds.extend(p1).extend(p2); //防止箭头因局部刷新没有清除
            }
          }
          break;
      }

    }
  },
  /**
   * 重写 fillStroke 用于填充样式
   * @param {*} ctx 
   * @param {*} layer 
   * @property {horizontal|vertical|cross|forwardDiagonal|backwardDiagonal} pattern  
   * 注：当两个layer绘制内容非常近，引发重绘，且options中的fillColor以及color是无效值的话，会引发交叉渲染，样式混乱
   */
  _fillStroke(ctx, layer) {
    let {
      options,
      _point
    } = layer;
    let {
      fill,
      stroke,
      weight,
      gradient
    } = options;
    //

    if (fill) {
      let {
        pattern,
        fillColor,
        color
      } = options;
      if (pattern) {
        let cvs = T.canvas();
        cvs.width = cvs.height = 12;
        let ctx2 = cvs.getContext('2d');
        ctx2.globalAlpha = 1;
        ctx2.beginPath();
        ctx2.strokeStyle = fillColor || color;
        //
        switch (pattern) {
          case 'horizontal': //(水平)
            ctx2.moveTo(0, 6);
            ctx2.lineTo(12, 6);
            break;
          case 'vertical': //(垂直)
            ctx2.moveTo(6, 0);
            ctx2.lineTo(6, 12);
            break;
          case 'cross': //(十字)
            ctx2.moveTo(0, 6);
            ctx2.lineTo(12, 6);
            ctx2.moveTo(6, 0);
            ctx2.lineTo(6, 12);
            break;
          case 'forwardDiagonal': //(正向斜角)
            ctx2.moveTo(0, 0);
            ctx2.lineTo(12, 12);
            break;
          case 'backwardDiagonal': //(反向斜角)
            ctx2.moveTo(12, 0);
            ctx2.lineTo(0, 12);
            break;
        }
        //
        ctx2.stroke();
        pattern = ctx.createPattern(cvs, 'repeat');

      } else {
        if (gradient) {
          gradient = ctx.createRadialGradient(_point.x, _point.y, 10, _point.x, _point.y, 100) //创建一个渐变色线性对象
          gradient.addColorStop(0, "yellow");
          gradient.addColorStop(1, "blue");
          fillColor = gradient;
        }
        ctx.globalAlpha = options.fillOpacity;
      }
      ctx.fillStyle = pattern || fillColor || color;
      ctx.fill(options.fillRule || 'evenodd');
    }
    //
    if (stroke && weight !== 0) {
      ctx.setLineDash && ctx.setLineDash(options._dashArray || []); //ie10+
      ctx.globalAlpha = options.opacity;
      ctx.lineWidth = weight;
      ctx.strokeStyle = options.color;
      ctx.lineCap = options.lineCap;
      ctx.lineJoin = options.lineJoin;
      if (options.shadowColor) {
        ctx.shadowColor = options.shadowColor;
        ctx.shadowBlur = options.shadowBlur;
      }
      ctx.stroke();
    }
    //
  }
})


/**
 * 动画层
 */
L.Animate = Canvas.extend({
  options: {
    style: {
      zIndex: (isIE && isIE < 11) ? 50 : 150,
      pointerEvents: 'none'
    }
  },
  /**
   * 
   */
  getEvents() {
    var events = L.Renderer.prototype.getEvents.call(this);
    events.viewprereset = this._onViewPreReset;
    events.zoomstart = this._onZoomStart;
    return events;
  },
  /**
   * 
   */
  _initPath(layer) {
    this._layers[L.stamp(layer)] = layer;
    let {
      options
    } = layer;
    options.glowOptions = $assign({
      // 扩散半径
      radius: 16,
      // 半径单位
      unit: 'px',
      // 粗细
      lineWidth: 2,
      // 重叠个数
      overlap: 0,
      // 扩散速度
      speed: 0.25,
      // 颜色
      color: '#ff0000'
    }, options.glowOptions)
    //
    options.flowOptions = $assign({
      // 移动点半径
      radius: 2,
      // 线条宽度
      lineWidth: 1,
      // 移动点颜色
      fillColor: '#fff',
      // 移动点阴影颜色
      shadowColor: '#fff',
      // 移动点阴影大小
      shadowBlur: 5,
      // 移动速度
      speed: 1, //有可能是一个方法
      //
      // src:'',
      //

    }, options.flowOptions);
  },
  _onZoomStart() {
    this._update();
  },
  _addPath() {},
  _removePath(layer) {
    delete this._layers[L.stamp(layer)];
  },
  /**
   * 
   */
  onAdd: function () {
    Canvas.prototype.onAdd.call(this);
    //
    var drawFrame = () => {
      let {
        _ctx: ctx,
        _container
      } = this;
      let {
        _leaflet_pos
      } = _container;
      // 判断是否被移除，jsdemo
      if (_container.clientWidth) {
        ctx.fillStyle = 'rgba(0, 0, 0, 0)';
        ctx.clearRect(_leaflet_pos.x, _leaflet_pos.y, _container.width, _container.height);
        for (var id in this._layers) {
          let marker = this._layers[id];
          if (marker instanceof Polyline) {
            this._updatePolyline(marker)
          } else {
            let {
              bounce,
              rotate,
              animate
            } = marker.options;
            if (bounce || rotate) {
              this._updateIcon(marker);
            } else if (!animate) {
              this._updateCircle(marker);
            } else {
              switch (animate.type) {
                case 'flame':
                  this._updateFlame(marker);
                  break;
                case 'firework':
                  this._updateFirework(marker);
                  break;
              }
            }
          }
        }
      }

      requestAnimFrame(drawFrame);
    }
    drawFrame();
  },
  /**
   * 重写 _updatePaths
   */
  _updatePaths() {},
  /**
   * 
   */
  _updateIcon(layer) {
    let that = this;
    let img = layer._loader;
    if (!img) return;
    let {
      _ctx: ctx,
    } = that;
    let p = layer._point;

    //
    let {
      options
    } = layer;
    // 弹跳动画
    if (options.bounce) {
      let bounce = options._bounce = options._bounce || {
        from: 0,
        to: 15,
        y: 0
      };
      if (bounce.from < bounce.to) {
        bounce.y += 1;
        if (bounce.y > bounce.to) {
          let temp = bounce.to;
          bounce.to = bounce.from;
          bounce.from = temp;
        }
      } else {
        bounce.y -= 1;
        if (bounce.y < bounce.to) {
          let temp = bounce.to;
          bounce.to = bounce.from;
          bounce.from = temp;
        }
      }
      p = p.clone();
      p.y -= bounce.y;
    }
    // 旋转动画
    let {
      x,
      y
    } = p;
    if (options.rotate) {
      let rotate = options._rotate = options._rotate || {
        deg: 0
      };
      // let { rotateOptions } = options; // 默认逆时针旋转，台风
      ctx.save();
      ctx.beginPath();
      ctx.translate(x, y);
      ctx.rotate(rotate.deg * Math.PI / 180);
      ctx.drawImage(img, -img.width / 2, -img.height / 2)
      ctx.restore();
      rotate.deg -= 5;
    } else {
      ctx.drawImage(img, x - img.width / 2, y - img.height / 2);
    }
  },

  /**
   * 绘制圆,绘制圆形扩散动画
   * @param layer  
   */
  _updateCircle(layer) {
    let {
      _ctx: ctx
    } = this;
    let {
      _point: p,
      options
    } = layer;
    //
    options = options.glowOptions;
    let {
      radius: to,
      speed,
      overlap
    } = options;
    let radius = options._radius || 0;
    //
    if (options.unit === 'm') { //
      let {
        _map: map,
        _latlng: latlng
      } = layer;
      let {
        crs
      } = map.options;
      crs = L.CRS.EPSG3857; //todo 暂时
      let latlng2 = crs.unproject(crs.project(latlng).subtract([to, 0]));
      to = p.x - map.latLngToLayerPoint(latlng2).x;
    }
    //
    ctx.beginPath();
    ctx.strokeStyle = options.color;
    ctx.lineWidth = options.lineWidth;
    ctx.arc(p.x, p.y, radius, 0, Math.PI * 2);
    ctx.stroke();
    ctx.closePath();
    // 绘制重叠圆，wifi
    if (overlap && radius > to / overlap && radius < to) {
      let r = radius;
      while (r > to / overlap) {
        ctx.beginPath();
        ctx.strokeStyle = options.color;
        ctx.lineWidth = options.lineWidth;
        ctx.arc(p.x, p.y, r -= to / overlap, 0, Math.PI * 2);
        ctx.stroke();
        ctx.closePath();
      }
    }
    //
    if (radius + speed > to) {
      radius = overlap ? (radius - to / overlap) : 0;
    } else {
      radius += speed;
    }
    //
    options._radius = radius;
  },
  /**
   * noClip 最好设置为true
   * 绘制线,绘制流动的线
   * @param layer
   * 
   * speedFn(e) 返回 0 则 停止,返回e.options.speed 则保持原速度，返回其他数值则是修改速度
   */
  _updatePolyline(layer) {
    // 默认参数
    let {
      _ctx: ctx
    } = this;
    let {
      _parts: parts,
      _latlngs,
      options
    } = layer;
    let len = parts.length;
    if (!len) {
      return;
    }
    options = options.flowOptions;
    //
    ctx.fillStyle = options.fillColor;
    ctx.shadowColor = options.shadowColor;
    ctx.shadowBlur = options.shadowBlur;
    //
    let flows = options._flows = options._flows || [];
    //
    // parts 即使是单线段，在窗口无法全部展示，同时有多个被截断的线段在视野内，parts.length>1
    parts.forEach((line, index) => {
      let points = getPoints(line);
      if (points.length > 0) {
        let ci = flows[index];
        if (!ci || ci >= points.length) {
          ci = flows[index] = 0;
        }
        ci = Math.floor(ci);
        let point = points[ci]
        let event = {
          points,
          point,
          index: ci,
          options
        };
        let [x, y] = point;
        let offset = options.offset; //图片经常需要偏移
        if (offset) {
          x += offset[0];
          y += offset[1];
        }
        if (options.renderFn) { // 自定义绘制方式
          options.renderFn(ctx, x, y);
        } else if (options.src) { // 绘制流动的图片：人、飞机、小车
          load(options.src).then(img => {
            ctx.beginPath();
            ctx.drawImage(img, x - img.width / 2, y - img.height);
            ctx.closePath();
          })
        } else if (options.symbol) {
          let symbol = options.symbol;
          switch (symbol.type) {
            case 'arrow':
            default:

              ctx.beginPath();
              ctx.fillStyle = ctx.strokeStyle = symbol.color || options.color;
              let _buildArrowPath = function (a, b) {
                let d2r = Math.PI / 180;
                let angle = (Math.atan2(b.y - a.y, b.x - a.x) * 180 / Math.PI + 90 + 360) % 360;

                let direction = -(angle - 90) * d2r;
                let radianArrowAngle = 60 / 2 * d2r; //默认60°
                //
                let pixelSize = symbol.size || 10; //默认10
                let headAngle1 = direction + radianArrowAngle;
                let headAngle2 = direction - radianArrowAngle;
                let arrowHead1 = toPoint(b.x - pixelSize * Math.cos(headAngle1), b.y + pixelSize * Math.sin(headAngle1));
                let arrowHead2 = toPoint(b.x - pixelSize * Math.cos(headAngle2), b.y + pixelSize * Math.sin(headAngle2));
                return [arrowHead1, arrowHead2];
              }
              //
              let from = points[ci - (symbol.size ? symbol.size * 5 : 10)] || points[0];
              let to = {
                x,
                y
              };
              let [p1, p2] = _buildArrowPath({
                x: from[0],
                y: from[1]
              }, to);
              //
              ctx.moveTo(to.x, to.y);
              ctx.lineTo(p1.x, p1.y);
              ctx.lineTo(p2.x, p2.y);
              ctx.closePath();
              ctx.fill();
              break;
          }

        } else {
          ctx.beginPath();
          ctx.arc(x, y, options.radius, 0, Math.PI * 2, true);
          ctx.fill();
          ctx.closePath();
        }

        layer.fire('flow', event);
        flows[index] += options.speedFn ? options.speedFn(event) : options.speed;
      }
    });
  },
  _updateFlame(layer) {
    let {
      _ctx: ctx
    } = this;
    let {
      _point: p,
      options
    } = layer;
    //
    let animate = options.__flame = options.__flame || flame();
    //
    animate({
      ctx,
      x: p.x,
      y: p.y
    });
  },
  _updateFirework(layer) {
    let {
      _ctx: ctx
    } = this;
    let {
      _point: p,
      options
    } = layer;
    //
    let animate = options.__firework = options.__firework || firework();
    //
    animate({
      ctx,
      x: p.x,
      y: p.y
    });
  }
})


/**
 * 闪烁光晕层
 */
L.Glow = L.Animate.extend({
  /**
   * 
   */
  onAdd() {
    Canvas.prototype.onAdd.call(this);
    //
    let {
      _ctx: ctx,
      _container
    } = this;
    let {
      _leaflet_pos
    } = _container;
    //
    let drawFrame = () => {
      if (_container.clientWidth) {
        // 默认值为source-over
        var prev = ctx.globalCompositeOperation;
        // 只显示canvas上原图像的重叠部分
        ctx.globalCompositeOperation = 'destination-in';
        // 设置透明度
        ctx.fillStyle = 'rgba(0,0,0,.9)';
        // 设置主canvas的绘制透明度
        ctx.fillRect(_leaflet_pos.x, _leaflet_pos.y, _container.width, _container.height);
        // global
        ctx.globalCompositeOperation = prev;
        // 
        for (var id in this._layers) {
          let marker = this._layers[id];
          if (marker instanceof Polyline) {
            this._updatePolyline(marker)
          } else {
            if (marker.options.bounce) {
              this._updateIcon(marker);
            } else {
              this._updateCircle(marker);
            }
          }
        }
      }
      requestAnimFrame(drawFrame);
    }
    drawFrame()
  }
})

/**
 * 获取线上的点集合
 * @param {Array} line 
 */
let getPoints = line => {
  var points = [];
  if (line.length < 2) {
    return;
  }
  for (var i = 0; i < line.length; i++) {
    var start = line[i];
    var end = line[i + 1];
    if (start && end) {
      start = [start.x, start.y];
      end = [end.x, end.y];
      var distance = Math.floor(getDistance(start, end));
      var vx = (end[0] - start[0]) / distance;
      var vy = (end[1] - start[1]) / distance;
      for (var j = 0; j < distance; j++) {
        points.push([start[0] + vx * j, start[1] + vy * j]);
      }
    }
  }
  return points;
};

/**
 * 获取两点之间距离
 * @param {*} p1 
 * @param {*} p2 
 */
let getDistance = (p1, p2) => Math.sqrt((p1[0] - p2[0]) * (p1[0] - p2[0]) + (p1[1] - p2[1]) * (p1[1] - p2[1]));



// WEBPACK FOOTER //
// ./src/polyfill/Renderer.js